import { render, staticRenderFns } from "./CommentCard.vue?vue&type=template&id=b5bcf646"
import script from "./CommentCard.vue?vue&type=script&lang=ts"
export * from "./CommentCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports